import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProductSection() {
  const benefits = [{
    icon: '📘',
    title: 'El Manual SOS (PDF Principal)',
    desc: 'Tu hoja de ruta completa para tus primeros 7 minutos del día. No genérico. Diseñado específicamente para la ventana de vulnerabilidad matutina que nadie más aborda.',
    change: 'Dejas de improvisar cada mañana. Tienes un sistema que funciona aunque estés medio dormido.'
  }, {
    icon: '🛏️',
    title: 'Técnica del "Lado de Escape"',
    desc: 'La posición exacta con almohadas que reduce la presión nocturna sobre el nervio. Específica para hernias L4-L5 y L5-S1 — las más comunes en personas de 40–50 años.',
    change: 'Empiezas a acumular horas de sueño reparador en lugar de horas de compresión sostenida.'
  }, {
    icon: '🚗',
    title: 'Ergonomía de Guerrilla',
    desc: 'Cómo ajustar tu asiento de coche y tu silla de oficina en menos de 30 segundos. Sin gadgets. Sin accesorios costosos. Con lo que ya tienes.',
    change: 'El trabajo y el trayecto dejan de ser factores agravantes. Dejan de acumular tensión.'
  }, {
    icon: '⚔️',
    title: 'El "Descenso de Comando"',
    desc: 'La secuencia exacta para salir de la cama sin el impacto gravitacional que dispara el nervio. Paso a paso. Con ilustraciones. En menos de 2 minutos.',
    change: 'Pones los pies en el suelo sin el miedo de qué va a pasar. El día empieza diferente.'
  }, {
    icon: '🚨',
    title: 'Checklist de Emergencia',
    desc: "Para imprimir o guardar en el celular. Úsala incluso medio dormido a las 5am. Incluye la sección de 'Red Flags' — señales que indican cuándo debes parar y llamar al médico.",
    change: 'Tienes un plan claro en el peor momento. No pánico. No improvisación.'
  }];
  return <section className="bg-slate-50 text-slate-800 py-24 px-4" data-id="element-247">
      <div className="max-w-5xl mx-auto" data-id="element-248">
        <div className="text-center mb-16" data-id="element-249">
          <p className="text-xl font-bold text-slate-500 uppercase tracking-widest mb-4" data-id="element-250">
            Presentando:
          </p>
          <h2 className="text-5xl md:text-7xl font-extrabold text-slate-900 mb-6" data-id="element-251">
            CIÁTICA SOS
          </h2>
          <p className="text-2xl md:text-3xl font-bold text-blue-600 mb-12" data-id="element-252">
            El Protocolo de 7 Minutos desde la Cama
          </p>

          <div className="max-w-3xl mx-auto bg-white p-8 rounded-2xl shadow-xl border border-slate-200 mb-16" data-id="element-253">
            <p className="text-xl leading-relaxed text-slate-700" data-id="element-254">
              Un manual digital (PDF) con instrucciones visuales paso a paso,
              sin relleno, sin teoría innecesaria, sin movimientos que requieran
              un fisioterapeuta al lado.
            </p>
            <p className="text-2xl font-extrabold text-slate-900 mt-6" data-id="element-255">
              Solo lo que funciona. En el orden correcto. En el momento
              correcto.
            </p>
          </div>
        </div>

        <div className="mb-20" data-id="element-256">
          <h3 className="text-3xl md:text-4xl font-extrabold text-center mb-12 text-slate-900" data-id="element-257">
            Lo que está dentro de CIÁTICA SOS:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-258">
            {benefits.map((item, idx) => <div key={idx} className={`bg-white p-8 rounded-2xl shadow-md border border-slate-200 flex flex-col ${idx === 0 ? 'md:col-span-2 md:flex-row gap-8 items-center bg-blue-50 border-blue-200' : ''}`} data-id="element-259">
                <div className="text-5xl mb-4 md:mb-0" data-id="element-260">{item.icon}</div>
                <div data-id="element-261">
                  <h4 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-262">
                    {item.title}
                  </h4>
                  <p className="text-slate-600 mb-6 text-lg" data-id="element-263">{item.desc}</p>
                  <div className="bg-green-50 p-4 rounded-lg border border-green-100 flex items-start gap-3" data-id="element-264">
                    <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-265" />
                    <p className="text-green-800 font-semibold" data-id="element-266">
                      <span className="font-bold uppercase text-sm tracking-wider block mb-1" data-id="element-267">
                        Lo que cambia:
                      </span>
                      {item.change}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-268">
          <CTAButton data-id="element-269">DESCARGAR EL PROTOCOLO AHORA MISMO</CTAButton>
        </div>
      </div>
    </section>;
}